import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  loading: boolean;
  tabIndex: number;
  userList: Array<LeaderBoardItem>;
  filterList: Array<LeaderBoardItem>;
  page: number;
  filterFlag: boolean;
  courseIds: Array<{}>;
  userIds: Array<{}>;
  userData: Array<{}>;
  leaderBoardList: Array<{}>;
  originalList: Array<LeaderBoardItem>;
  selectedRank: {
    min: number;
    max: number;
  };
  selectedScore: {
    min: number;
    max: number;
  };
  selectedCourse: Array<string | number>;
  selectedUser: Array<string | number>;
  token: string;
  ranges: Array<Range>;
  rangeIdToDelete: string;
  createRangeModalOpen: boolean;
  rangeTextFields: Array<RangeTextField>;
  createMappingModalOpen: boolean;
  createMappingCourseId: number | null;
  createMappingRangeId: number | null;
  errors: string;
  updateMapping: boolean;
  updateRangeData: RangeData;
  ranking: Array<LeaderBoardItem>;
  leaderboard: Array<LeaderBoardItem>;
  courses: Array<CoursesResponse>;
  selectedCourseForLeaderBoard: number | null;
  selectedCourseName: string;
  userRankings: Array<LeaderBoardItem>;
  userRole: "user" | "admin" | "";
  // Customizable Area End
}

// Customizable Area Start
export interface Range {
  id: string;
  type: string;
  attributes: {
    id: number;
    account_id: number;
    range_data: RangeData;
  };
}

export interface RangeData {
  [key: string]: string;
}

interface CreateRangeRequest {
  range: {
    range_data: RangeData;
  };
}

interface CreateMappingRequest {
  range_id: number;
}

interface UpdateMappingRequest {
  range_id: number;
  course_id: number;
  range_data: RangeData;
}

interface RangeTextField {
  id: number;
  rangeField: string;
  starField: string;
}

export interface DropdownField {
  value: string;
  id: number;
}

export interface LeaderBoardItem {
  id: number;
  account_id: number;
  performance_tracker_course_id: number;
  total: string;
  ranking: number;
  top_score: number;
  created_by: number;
  range_id: number;
  course_name?: string;
}

interface LeaderBoardResponse {
  id: string;
  type: string;
  attributes: LeaderBoardItem;
}

export interface CoursesResponse {
  id: string;
  type: string;
  attributes: {
    id: number;
    name: string;
    description: string;
    enabled: boolean;
    created_at: Date;
    updated_at: Date;
  };
}
// Customizable Area End

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

// Customizable Area Start
const rangeTextFieldsDefault = [
  {
    id: 1,
    rangeField: "",
    starField: "",
  },
];
// Customizable Area Start

export default class GamificationController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  getRangesCallId: string = "";
  deleteRangesCallId: string = "";
  createRangeCallId: string = "";
  createMappingCallId: string = "";
  updateMappingCallId: string = "";
  getLeaderboardCallId: string = "";
  getPerformanceTrackerCoursesCallId: string = "";
  getUserRankingCallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionResponseMessage),
      // Customizable Area Start
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      loading: true,
      tabIndex: 0,
      userList: [],
      filterList: [],
      page: 1,
      filterFlag: false,
      courseIds: [],
      userIds: [],
      userData: [],
      leaderBoardList: [],
      originalList: [],
      selectedUser: [],
      selectedCourse: [],
      selectedRank: {
        min: 1,
        max: 5,
      },
      selectedScore: {
        min: 1,
        max: 100,
      },
      token: "",
      ranges: [],
      rangeIdToDelete: "",
      createRangeModalOpen: false,
      rangeTextFields: rangeTextFieldsDefault,
      createMappingModalOpen: false,
      createMappingCourseId: null,
      createMappingRangeId: null,
      errors: "",
      updateMapping: false,
      updateRangeData: { "0-5": "1", "5-9": "2", "10-15": "3" },
      ranking: [],
      leaderboard: [],
      courses: [],
      selectedCourseForLeaderBoard: null,
      selectedCourseName: "",
      userRankings: [],
      userRole: "",
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    runEngine.debugLog("Message Recived", message);

    if (message.id === getName(MessageEnum.SessionResponseMessage)) {
      let token = message.getData(getName(MessageEnum.SessionResponseToken));
      this.setState({ loading: false, token: token }, () => {
        this.sendGetCoursesRequest();
        this.sendUserRankingRequest();
        this.sendLeaderBoardRequest();
      });
    } else if (
      message.id === getName(MessageEnum.RestAPIResponceMessage) &&
      this.getRangesCallId ===
        message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const errorResponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (errorResponse) {
        this.setState({ loading: false });
        this.showAlert(configJSON.error, errorResponse);
      }

      if (responseJson && responseJson.data) {
        this.setState({
          loading: false,
          ranges: responseJson.data,
        });
      }
      if (responseJson && responseJson.errors) {
        this.setState({ loading: false });
        this.parseApiErrorResponse(responseJson.errors);
      }
    } else if (
      message.id === getName(MessageEnum.RestAPIResponceMessage) &&
      this.deleteRangesCallId ===
        message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const errorResponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (errorResponse) {
        this.setState({ loading: false });
        this.showAlert(configJSON.error, errorResponse);
      }

      if (responseJson && responseJson.message) {
        this.deleteRangeFromState();
        this.showAlert(configJSON.success, responseJson.message);
      }
      if (responseJson && responseJson.errors) {
        this.setState({ loading: false });
        this.parseApiErrorResponse(responseJson.errors);
      }
    } else if (
      message.id === getName(MessageEnum.RestAPIResponceMessage) &&
      this.createRangeCallId ===
        message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const errorResponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (errorResponse) {
        this.setState({ createRangeModalOpen: false, loading: false }, () =>
          this.showAlert(configJSON.error, errorResponse)
        );
      }

      if (responseJson && responseJson.data) {
        this.setState(
          {
            ranges: [...this.state.ranges, responseJson.data],
            createRangeModalOpen: false,
            loading: false,
            rangeTextFields: rangeTextFieldsDefault,
          },
          () => this.showAlert(configJSON.success, configJSON.success)
        );
      }
      if (responseJson && responseJson.errors) {
        this.setState({ createRangeModalOpen: false, loading: false }, () =>
          this.parseApiErrorResponse(responseJson.errors)
        );
      }

      if (responseJson && responseJson.message) {
        this.setState(
          {
            createRangeModalOpen: false,
            loading: false,
          },
          () =>
            this.showAlert(
              configJSON.error,
              JSON.stringify(responseJson.message)
            )
        );
      }
    } else if (
      message.id === getName(MessageEnum.RestAPIResponceMessage) &&
      this.createMappingCallId ===
        message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const errorResponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (errorResponse) {
        this.setState({ createMappingModalOpen: false, loading: false }, () =>
          this.showAlert(configJSON.error, errorResponse)
        );
      }

      if (responseJson && responseJson.data) {
        this.setState(
          {
            createMappingModalOpen: false,
            loading: false,
            createMappingCourseId: null,
            createMappingRangeId: null,
          },
          () => this.showAlert(configJSON.success, configJSON.success)
        );
      }
      if (responseJson && responseJson.errors) {
        this.setState({ createMappingModalOpen: false, loading: false }, () =>
          this.parseApiErrorResponse(responseJson.errors)
        );
      }
      if (responseJson && responseJson.message) {
        this.setState(
          {
            createMappingModalOpen: false,
            loading: false,
          },
          () => this.showAlert(configJSON.error, responseJson.message)
        );
      }
    } else if (
      message.id === getName(MessageEnum.RestAPIResponceMessage) &&
      this.updateMappingCallId ===
        message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const errorResponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (errorResponse) {
        this.setState({ createMappingModalOpen: false, loading: false }, () =>
          this.showAlert(configJSON.error, errorResponse)
        );
      }

      if (responseJson && responseJson.data) {
        this.setState(
          {
            createMappingModalOpen: false,
            loading: false,
            createMappingCourseId: null,
            createMappingRangeId: null,
          },
          () => this.showAlert(configJSON.success, configJSON.success)
        );
      }
      if (responseJson && responseJson.errors) {
        this.setState({ createMappingModalOpen: false, loading: false }, () =>
          this.parseApiErrorResponse(responseJson.errors)
        );
      }
      if (responseJson && responseJson.message) {
        this.setState(
          {
            createMappingModalOpen: false,
            loading: false,
          },
          () => this.showAlert(configJSON.error, responseJson.message)
        );
      }
    } else if (
      message.id === getName(MessageEnum.RestAPIResponceMessage) &&
      this.getLeaderboardCallId ===
        message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const errorResponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (errorResponse) {
        this.setState({ loading: false }, () =>
          this.showAlert(configJSON.error, errorResponse)
        );
      }

      if (responseJson && responseJson.data) {
        const leaderboardResponse =
          responseJson.data as Array<LeaderBoardResponse>;
        const leaderBoardItems = leaderboardResponse.map(
          (item) => item.attributes
        );

        this.setState(
          {
            loading: false,
            leaderboard: leaderBoardItems,
          },
          () => {
            this.addCourseInfoToLeaderBoard();
          }
        );
      }
      if (responseJson && responseJson.errors) {
        this.setState({ loading: false }, () =>
          this.parseApiErrorResponse(responseJson.errors)
        );
      }
    } else if (
      message.id === getName(MessageEnum.RestAPIResponceMessage) &&
      this.getPerformanceTrackerCoursesCallId ===
        message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const errorResponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (errorResponse) {
        this.setState({ loading: false }, () =>
          this.showAlert(configJSON.error, errorResponse)
        );
      }

      if (responseJson && responseJson.data) {
        this.setState(
          {
            loading: false,
            courses: responseJson.data,
          },
          () => {
            this.sendLeaderBoardRequest();
          }
        );
      }
      if (responseJson && responseJson.errors) {
        this.setState({ loading: false }, () =>
          this.parseApiErrorResponse(responseJson.errors)
        );
      }
    } else if (
      message.id === getName(MessageEnum.RestAPIResponceMessage) &&
      this.getUserRankingCallId ===
        message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const errorResponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (errorResponse) {
        this.setState({ loading: false }, () =>
          this.showAlert(configJSON.error, errorResponse)
        );
      }

      if (responseJson && responseJson.data) {
        const userRankingResponse =
          responseJson.data as Array<LeaderBoardResponse>;
        const userRankingItems = userRankingResponse.map(
          (item) => item.attributes
        );

        this.setState(
          {
            loading: false,
            userRankings: userRankingItems,
          },
          () => {
            this.addCourseInfoToRankings();
          }
        );
      }
      if (responseJson && responseJson.errors) {
        this.setState({ loading: false }, () =>
          this.parseApiErrorResponse(responseJson.errors)
        );
      }
      if (responseJson && responseJson.message) {
        this.setState({ loading: false, userRankings: [] }, () =>
          this.showAlert(configJSON.error, responseJson.message)
        );
      }
    }
    // Customizable Area End

    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    this.getToken();
  }

  getToken = () => {
    const message: Message = new Message(
      getName(MessageEnum.SessionRequestMessage)
    );
    this.send(message);
  };

  sendLeaderBoardRequest = () => {
    if (this.state.courses.length === 0) {
      return;
    }

    let leaderboardCourseId = this.state.courses[0].attributes.id;

    if (this.state.selectedCourseForLeaderBoard) {
      leaderboardCourseId = this.state.selectedCourseForLeaderBoard;
    } else {
      this.setState({
        selectedCourseForLeaderBoard: leaderboardCourseId,
      });
    }

    this.setState({
      loading: true,
    });

    const header = {
      "Content-Type": "application/json",
      token: this.state.token,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getLeaderboardCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getLeaderboardApi +
        leaderboardCourseId +
        "?page=1&items_per_page=10"
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  sendGetCoursesRequest = () => {
    this.setState({ loading: true });
    const header = {
      "Content-Type": "application/json",
      token: this.state.token,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getPerformanceTrackerCoursesCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getPerformanceTrackerCoursesApi
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  sendUserRankingRequest = () => {
    if (this.state.courses.length === 0) {
      return;
    }

    let leaderboardCourseId = this.state.courses[0].attributes.id;

    if (this.state.selectedCourseForLeaderBoard) {
      leaderboardCourseId = this.state.selectedCourseForLeaderBoard;
    } else {
      this.setState({
        selectedCourseForLeaderBoard: leaderboardCourseId,
      });
    }

    this.setState({
      loading: true,
    });

    const header = {
      "Content-Type": "application/json",
      token: this.state.token,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getUserRankingCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getUserRankingApi + leaderboardCourseId
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  // get data of Rank
  getRankData = (isMobile: boolean = false) => {
    this.setState({ loading: true });
    const courseIds = this.state.userRankings.map((item: LeaderBoardItem) => {
      return {
        id: item["performance_tracker_course_id"],
        name: item["course_name"],
      };
    });
    const userIds = this.state.userRankings.map((item: LeaderBoardItem) => {
      return {
        id: item["account_id"],
        name: item["account_id"],
      };
    });

    const sortedRank = this.state.userRankings.sort(
      (
        first: {
          ranking: number;
        },
        second: {
          ranking: number;
        }
      ) => second.ranking - first.ranking
    );

    this.setState({
      userRankings: isMobile
        ? sortedRank?.slice(0, configJSON.itemsPerPage)
        : sortedRank,
      filterList: sortedRank,
      originalList: sortedRank,
      courseIds: this.removeDuplicateIds(courseIds),
      userIds: this.removeDuplicateIds(userIds),
      loading: false,
      selectedScore: {
        min: 1,
        max: Number((sortedRank?.[0] && sortedRank?.[0]?.["top_score"]) || 100),
      },
    });
  };

  // get leaderboard data
  getLeaderBoardData = (isMobile: boolean = false) => {
    this.setState({ loading: true });
    const courseIds = this.state.leaderboard.map((item: LeaderBoardItem) => {
      return {
        id: item["performance_tracker_course_id"],
        name: item["course_name"],
      };
    });
    const userIds = this.state.leaderboard.map((item: LeaderBoardItem) => {
      return {
        id: item["account_id"],
        name: item["account_id"],
      };
    });
    const sortedLeaderBoard = this.state.leaderboard.sort(
      (
        a: {
          ranking: number;
        },
        b: {
          ranking: number;
        }
      ) => b.ranking - a.ranking
    );
    this.setState({
      userList: isMobile
        ? sortedLeaderBoard?.slice(0, configJSON.itemsPerPage)
        : sortedLeaderBoard,
      originalList: sortedLeaderBoard,
      filterList: sortedLeaderBoard,
      courseIds: this.removeDuplicateIds(courseIds),
      userIds: this.removeDuplicateIds(userIds),
      loading: false,
      selectedScore: {
        min: 1,
        max: Number(
          (sortedLeaderBoard?.[0] && sortedLeaderBoard?.[0]?.["top_score"]) ||
            100
        ),
      },
    });
  };

  // handle reset
  resetHandle = (isMobile: boolean = false) => {
    this.setState({
      filterFlag: false,
      selectedUser: [],
      selectedCourse: [],
      selectedRank: {
        min: 1,
        max: 5,
      },
      selectedScore: {
        min: 1,
        max: Number(
          (this.state.originalList?.[0] &&
            this.state.originalList?.[0]?.["top_score"]) ||
            100
        ),
      },
      page: 1,
      loading: false,
      filterList: this.state.originalList,
      userList: isMobile
        ? this.state.originalList?.slice(0, configJSON.itemsPerPage)
        : this.state.originalList,
    });
  };

  // handle tab change
  tabChange = (tab: number, isMobile: boolean = false) => {
    this.setState({
      tabIndex: tab,
      courseIds: [],
      userIds: [],
      filterFlag: false,
    });
    if (tab == 0) {
      this.getRankData(isMobile);
    }
    if (tab === 1) {
      this.getLeaderBoardData(isMobile);
    }
    if (tab === 2) {
      this.getRanges();
    }
    this.resetHandle(isMobile);
  };

  getRanges = () => {
    this.setState({ loading: true });
    const header = {
      "Content-Type": "application/json",
      token: this.state.token,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getRangesCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getRangesApi
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  // handle filter
  handleFilter = (isMobile: boolean = false) => {
    const {
      selectedCourse,
      originalList,
      selectedUser,
      selectedRank,
      selectedScore,
    } = this.state;
    this.setState({
      userList: [],
      loading: true,
      filterFlag: false,
      filterList: [],
    });
    let filterData: Array<LeaderBoardItem> = [];
    filterData = originalList.filter(
      (item) =>
        Number(item.ranking) >= selectedRank.min &&
        Number(item.ranking) <= selectedRank.max &&
        Number(item.total) >= selectedScore.min &&
        Number(item.total) <= selectedScore.max
    );
    if (selectedCourse.length > 0) {
      filterData = filterData.filter(
        (item) =>
          selectedCourse.indexOf(item.performance_tracker_course_id) !== -1
      );
    }
    if (selectedUser.length > 0) {
      filterData = filterData.filter(
        (item: LeaderBoardItem) =>
          selectedUser.indexOf(item["account_id"]) !== -1
      );
    }
    this.setState({
      userList: isMobile
        ? filterData?.slice(0, configJSON.itemsPerPage)
        : filterData,
      filterList: filterData,
      loading: false,
      page: 1,
    });
  };

  // handle  drop down min and max value
  populateDropdownMixMaxData = (min: number, max: number) => {
    return Array(Math.ceil(max - min) + 1)
      .fill(min)
      ?.map((x, y) => {
        return { value: x + y };
      });
  };

  // load more on mobile
  loadMoreData = () => {
    this.setState({ loading: true });
    const data = this.state.filterList.slice(
      (this.state.page + 1 - 1) * configJSON.itemsPerPage,
      (this.state.page + 1) * configJSON.itemsPerPage
    );
    this.setState({
      userList: [...this.state.userList, ...data],
      page: this.state.page + 1,
    });
    this.setState({ loading: false });
  };

  // handle filter
  setFilter = (value: boolean) => {
    this.setState({ filterFlag: value });
  };

  // get name by id
  getNameByID = (list: Array<{}>, selected: Array<{}>) => {
    const selecteduserName: Array<string> = [];
    list?.filter((e: { id?: string | number; name?: string }) =>
      selected.find((id) => {
        if (Number(e.id) == Number(id)) {
          selecteduserName.push(e.name as string);
        }
      })
    );
    return selecteduserName.join(", ");
  };

  //  remove duplicate id
  removeDuplicateIds = (list: Array<{}>) => {
    return list?.filter(
      (
        value: {
          id?: string;
          name?: string;
        },
        index: number,
        array: Array<Object>
      ) =>
        array.findIndex(
          (value2: { id?: string | number }) => value2.id === value.id
        ) === index
    );
  };

  //  handle min and max rank
  populateRankData = (minValue: number, maxValue: number) => {
    this.setState((prevState) => ({
      selectedRank: {
        ...prevState.selectedRank,
        min: minValue,
        max: maxValue,
      },
    }));
  };

  // handle min and max score
  populateScoreData = (minValue: number, maxValue: number) => {
    this.setState((prevState) => ({
      selectedScore: {
        ...prevState.selectedScore,
        min: minValue,
        max: maxValue,
      },
    }));
  };

  //handle course array
  populateCoursesData = (value: Array<string | number>) => {
    this.setState({ selectedCourse: value });
  };

  //handle users array
  populateUsersData = (value: Array<string | number>) => {
    this.setState({ selectedUser: value });
  };

  // get data as per page select
  getListPerPage = () => {
    if (this.state.tabIndex === 0) {
      return this.state.userRankings;
    } else {
      return this.state.userList.slice(
        (this.state.page - 1) * configJSON.itemsPerPage,
        this.state.page * configJSON.itemsPerPage
      );
    }
  };

  // page count
  getPageCount = () => {
    return Math.ceil(this.state.userList.length / configJSON.itemsPerPage);
  };

  // pagination
  setPagination = (value: number) => {
    this.setState({ page: value });
  };

  handleDeleteRange = (id: string) => {
    this.setState({ loading: true, rangeIdToDelete: id });
    const header = {
      "Content-Type": "application/json",
      token: this.state.token,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.deleteRangesCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.deleteRangeApi + id
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "DELETE"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  deleteRangeFromState = () => {
    const newRanges = this.state.ranges.filter(
      (range) => range.id !== this.state.rangeIdToDelete
    );
    this.setState({ loading: false, ranges: newRanges, rangeIdToDelete: "" });
  };

  handleCreateRangeModalOpen = () => {
    this.setState({ createRangeModalOpen: true });
  };

  handleCreateRangeModalClose = () => {
    this.setState({ createRangeModalOpen: false });
  };

  handleChangeRangeField = (text: string, fieldId: number) => {
    let allRangeTextFields = this.state.rangeTextFields;

    const indx = allRangeTextFields.findIndex((item) => item.id === fieldId);

    allRangeTextFields[indx] = {
      ...allRangeTextFields[indx],
      rangeField: text,
    };

    this.setState({ rangeTextFields: allRangeTextFields });
  };

  handleChangeValueField = (text: string, fieldId: number) => {
    let allRangeTextFields = this.state.rangeTextFields;

    const indx = allRangeTextFields.findIndex((item) => item.id === fieldId);

    allRangeTextFields[indx] = {
      ...allRangeTextFields[indx],
      starField: text,
    };

    this.setState({ rangeTextFields: allRangeTextFields });
  };

  handleCreateRange = () => {
    this.setState({ loading: true });
    const header = {
      "Content-Type": "application/json",
      token: this.state.token,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.createRangeCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.createRangeApi
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );

    const requestBody: CreateRangeRequest = {
      range: {
        range_data: this.createRangeData(),
      },
    };

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(requestBody)
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  createRangeData = (): RangeData => {
    let rangeData: RangeData = {};

    this.state.rangeTextFields.forEach((item) => {
      let newRangeData: RangeData = {
        [item.rangeField]: item.starField,
      };

      rangeData = { ...rangeData, ...newRangeData };
    });

    return rangeData;
  };

  addRangeTextField = () => {
    let maxIndex = 0;
    this.state.rangeTextFields.forEach((item) => {
      if (item.id > maxIndex) {
        maxIndex = item.id;
      }
    });

    this.setState({
      rangeTextFields: [
        ...this.state.rangeTextFields,
        { id: maxIndex + 1, rangeField: "", starField: "" },
      ],
    });
  };

  removeTextField = (fieldId: number) => {
    const newFields = this.state.rangeTextFields.filter(
      (item) => item.id !== fieldId
    );
    this.setState({
      rangeTextFields: newFields,
    });
  };

  handleCreateMappingModalOpen = (isUpdate: boolean) => {
    this.setState({ createMappingModalOpen: true, updateMapping: isUpdate });
  };

  handleCreateMappingModalClose = () => {
    this.setState({ createMappingModalOpen: false });
  };

  handleCreateMapping = () => {
    const {
      createMappingCourseId,
      createMappingRangeId,
      updateMapping,
      updateRangeData,
    } = this.state;

    if (createMappingCourseId && createMappingRangeId) {
      this.setState({ errors: "" });
      if (updateMapping) {
        if (!updateRangeData) {
          this.setState({ errors: configJSON.createMappingError });
          return;
        }
        this.sendUpdateMappingRequest(
          createMappingCourseId,
          createMappingRangeId
        );
      } else {
        this.sendCreateMappingRequest(
          createMappingCourseId,
          createMappingRangeId
        );
      }
    } else {
      this.setState({ errors: configJSON.createMappingError });
    }
  };

  sendUpdateMappingRequest = (
    createMappingCourseId: number,
    createMappingRangeId: number
  ) => {
    this.setState({ loading: true });
    const header = {
      "Content-Type": "application/json",
      token: this.state.token,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.updateMappingCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.updateMappingApi
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "PUT"
    );

    const requestBody: UpdateMappingRequest = {
      range_id: createMappingRangeId,
      course_id: createMappingCourseId,
      range_data: this.state.updateRangeData,
    };

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(requestBody)
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  sendCreateMappingRequest = (
    createMappingCourseId: number,
    createMappingRangeId: number
  ) => {
    this.setState({ loading: true });
    const header = {
      "Content-Type": "application/json",
      token: this.state.token,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.createMappingCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.createMappingApi + createMappingCourseId.toString()
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );

    const requestBody: CreateMappingRequest = {
      range_id: createMappingRangeId,
    };

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(requestBody)
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleCourseIdTextChange = (courseId: number) => {
    this.setState({ createMappingCourseId: courseId });
  };
  handleRangeIdTextChange = (rangeId: number) => {
    this.setState({ createMappingRangeId: rangeId });
  };

  addCourseInfoToLeaderBoard = () => {
    const newLeaderBoard = this.state.leaderboard.map((item) => {
      const course = this.state.courses.find(
        (course) => course.attributes.id === item.performance_tracker_course_id
      );
      if (course) {
        item.course_name = course.attributes.name;
      }
      return item;
    });

    this.setState({ leaderboard: newLeaderBoard }, () =>
      this.getLeaderBoardData()
    );
  };

  addCourseInfoToRankings = () => {
    const newRankings = this.state.userRankings.map((item) => {
      const course = this.state.courses.find(
        (course) => course.attributes.id === item.performance_tracker_course_id
      );
      if (course) {
        item.course_name = course.attributes.name;
      }
      return item;
    });

    this.setState({ userRankings: newRankings }, () => this.getRankData());
  };

  handleCourseChangeMobile = (
    value: string,
    index: number,
    data: Array<DropdownField>
  ) => {
    this.setState({ selectedCourseName: value });
    this.handleSelectedCourseChange(data[index].id);
  };

  handleSelectedCourseChange = (value: number) => {
    this.setState({ selectedCourseForLeaderBoard: value }, () => {
      if (this.state.tabIndex === 0) {
        this.sendUserRankingRequest();
      } else if (this.state.tabIndex === 1) {
        this.sendLeaderBoardRequest();
      }
    });
  };

  handleUserSelection = () => {
    this.setState({ userRole: "user" });
  };
  handleAdminSelection = () => {
    this.setState({ userRole: "admin" });
  };

  populateCoursesDropdown = () => {
    return this.state.courses.map((course) => {
      return { value: course.attributes.name, id: course.attributes.id };
    });
  };

  checkRoleForTab = (key: string): boolean => {
    const adminPages = ["Ranking", "LeaderBoard", "Ranges", "Mappings"];
    const userPages = ["Ranking", "LeaderBoard"];

    if (this.state.userRole === "admin") {
      return adminPages.includes(key);
    } else {
      return userPages.includes(key);
    }
  };
  // Customizable Area End
}
